import axiosInstance from "@/config/axios";
// import type { theIndex } from "@/modules/admin/types/actionPlans";
import type {
	FinancialDetail,
	FinancialPlan,
	TransformedData,
} from "@/modules/admin/types/actionPlans";

// const getActionPlan = async (id: string, year: number) => {
// 	// Remove leading and trailing double quotes from the `id`
// 	const cleanedId = id.replace(/^"(.+)"$/, "$1");

// 	// Declare `configs` variable outside the if blocks
// 	let configs: { params: Record<string, any> };

// 	// Conditional logic to populate `configs`
// 	if (year <= 1111) {
// 		configs = {
// 			params: {
// 				skip: 0,
// 				limit: 30,
// 				companyId: cleanedId,
// 			},
// 		};
// 	} else {
// 		configs = {
// 			params: {
// 				skip: 0,
// 				limit: 30,
// 				companyId: cleanedId,
// 				yearly: year,
// 			},
// 		};
// 	}

// 	// Make the API request
// 	const response = await axiosInstance.get("/financial-plans/company", configs);

// 	// Return the data from the API response
// 	return response.data;
// };

const getActionPlan = async (params?: {
	[key: string]: string | number | undefined;
}) => {
	const response = await axiosInstance.get("/financial-plans/company", {
		params,
	});
	return response.data;
};

const getActionPlanByYearly = async (params?: {
	[key: string]: string | number | undefined;
}) => {
	const response = await axiosInstance.get("/financial-plans/by-yearly", {
		params,
	});
	return response.data;
};

const getActionPlanDetails = async (id: string, TheYear: number) => {
	// console.log("actionPlanDetails tes id   00000,", id);
	// console.log("actionPlanDetails tes id,", id.length);

	// Clean the ID to remove any leading/trailing double quotes
	const cleanedId = id.replace(/^"(.+)"$/, "$1");
	const cleanedTheYear = TheYear;

	// Configuration for API request
	const configs = {
		params: {
			companyId: cleanedId,
			yearly: cleanedTheYear,
		},
	};

	// Make the API call
	const response = await axiosInstance.get("/financial-plans/report", configs);

	return response.data;
};
const getToEdit = async (id: string, TheYear: number) => {
	// console.log("actionPlanDetails tes id   00000,", id);
	// console.log("actionPlanDetails tes id,", id.length);

	// Clean the ID to remove any leading/trailing double quotes
	const cleanedId = id.replace(/^"(.+)"$/, "$1");

	// Configuration for API request
	const configs = {
		params: {
			companyId: cleanedId,
			TheYear,
		},
	};

	// Make the API call
	const response = await axiosInstance.get(`/financial-plans/${cleanedId}`);

	return response.data;
};

const AddActionPlan = async (data: {
	companyId: string;
	yearly: number;
	planName: string;
	finPlanDetails: {
		financialType: string;
		detailName: string;
		amount: number;
	}[];
	docFile: string;
	description: string;
}) => {
	console.log("AddActionPlan data:000000000000000000000000000", data);
	try {
		const response = await axiosInstance.post("/financial-plans", data);
		return response.data;
	} catch (error) {
		console.error("Error in AddActionPlan:", error);
		throw error;
	}
};

const putPlan = async (data: {
	companyId: string;
	yearly: number;
	planName: string;
	finPlanDetails: {
		financialType: string;
		detailName: string;
		amount: number;
	}[];
	docFile: string;
	description: string;
}) => {
	console.log("putPlan data:", data);
	try {
		const response = await axiosInstance.put("/financial-plans", data);
		return response.data;
	} catch (error) {
		console.error("Error in putPlan:", error);
		throw error;
	}
};

export {
	getActionPlan,
	getActionPlanByYearly,
	getActionPlanDetails,
	getToEdit,
	AddActionPlan,
	putPlan,
};
